import React, { useState, useEffect, useContext } from "react";
import { API_URL } from "../components/api";
import "bootstrap/dist/css/bootstrap.css";
import Axios from "axios";
import Select from "react-select";
import AuthContext from "../context/AuthContext";

function EditFiberCore(props) {
  const [message, setMessage] = useState(null);

  let { user } = useContext(AuthContext);
  let authTokens = JSON.parse(localStorage.getItem("authTokens"));
  const [code, setcode] = useState("");
  const [status, setstatus] = useState("");
  const [mgrs, setmgrs] = useState("");
  const [type, settype] = useState("");
  const [sticker, setsticker] = useState("");
  const [map, setmap] = useState("");
  const [fiber_meters, setfiber_meters] = useState("");
  const [parent_core, setparent_core] = useState("");
  const [parentCores, setparentCores] = useState([]);

  const showMessage = (message, type = "success") => {
    setMessage({ text: message, type });

    // Close the modal after 3 seconds
    setTimeout(() => {
      props.closeModal();
      props.fetch();
    }, 1200);

    // Clear the message after 5 seconds
    setTimeout(() => {
      setMessage(null);
    }, 1000);
  };

  const types = [
    { value: "P2C", label: "P2C" },
    { value: "C2C", label: "C2C" },
    { value: "B2C", label: "B2C" },
    { value: "C2B", label: "C2B" },
  ];
  const state = [
    { value: "Ready", label: "Ready" },
    { value: "Pending", label: "Pending" },
    { value: "Active", label: "Active" },
    { value: "Disabled", label: "Disabled" },
  ];
  const stickers = [
    { value: "Private", label: "Private" },
    { value: "NO", label: "NO" },
    { value: "Yes", label: "Yes" },
  ];
  const options = [
    { value: "YES", label: "YES" },
    { value: "NO", label: "NO" },
  ];

  // Fetch buildings from the backend
  useEffect(() => {
    Axios.get(`${API_URL}/radius/fiber/cores/`, {
      headers: {
        Authorization: `Bearer ${authTokens.access}`,
      },
      params: {
        username: user.username,
      },
    })
      .then((response) => {
        const cores = response.data.map((core) => ({
          value: core.code,
          label: core.code,
        }));
        setparentCores(cores);
      })
      .catch((error) => {
        console.error("Error fetching parent cores:", error);
      });
  }, []);

  let handleSubmit = async (e) => {
    e.preventDefault();
    Axios.post(
      `${API_URL}/radius/fiber/cores/`,
      {
        Action: "Put",
        core_id: props.core_id,
        code: code,
        sticker: sticker,
        status: status,
        mgrs: mgrs,
        type: type,
        map: map,
        fiber_meters: fiber_meters,
        parent_core: parent_core,
        userdealer: user.username,
      },
      {
        headers: {
          Authorization: `Bearer ${authTokens.access}`,
        },
      }
    )
      .then((response) => {
        console.log(response);
        showMessage("Edit successful!", "success"); // Show the success message
      })
      .catch((error) => {
        console.log(error);
        showMessage("Edit failed!", "danger"); // Show the error message
      });
  };

  return (
    <div className="testi">
      <div className="mod">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>
              Code:
              <input
                className="form-control"
                type="text"
                value={code}
                placeholder={props.code}
                onChange={(e) => setcode(e.target.value)}
              />
            </label>
            <label>
              Status:
              <Select
                className="search-line"
                placeholder={props.status}
                options={state}
                onChange={(opt) => setstatus(opt.value)}
              />
            </label>
            <label>
              Type:
              <Select
                className="search-line"
                placeholder={props.type}
                options={types}
                onChange={(opt) => settype(opt.value)}
              />
            </label>
          </div>
          <div className="form-group">
            <label>
              Sticker:
              <Select
                className="search-line"
                placeholder={props.sticker}
                options={stickers}
                onChange={(opt) => setsticker(opt.value)}
              />
            </label>
          </div>
          <div className="form-group">
            <label>
              MAP:
              <Select
                className="search-line"
                placeholder={props.map}
                options={options}
                onChange={(opt) => setmap(opt.value)}
              />
            </label>
          </div>
          <label>
            Location:
            <input
              className="form-control"
              type="text"
              value={mgrs}
              placeholder={props.mgrs}
              onChange={(e) => setmgrs(e.target.value)}
            />
          </label>
          <label>
            Fiber Meters:
            <input
              className="form-control"
              type="number"
              value={fiber_meters}
              placeholder={props.meters}
              onChange={(e) => setfiber_meters(e.target.value)}
            />
          </label>
          <div className="form-group">
            <label>
              Parent Core:
              <Select
                className="search-line"
                options={parentCores}
                onChange={(opt) => setparent_core(opt.value)}
                placeholder={props.parent_core}
              />
            </label>
          </div>
          <div className="fo">
            <button type="submit" className="btn btn-primary btn-md">
              Edit
            </button>
          </div>
        </form>
      </div>
      {/* Popup Message */}
      {message && (
        <div
          className={`alert alert-${message.type} alert-dismissible fade show`}
          role="alert"
          style={{
            position: "fixed",
            bottom: "10px",
            margin: "10px",
            right: "10px",
            zIndex: "9999",
          }}
        >
          {message.text}
        </div>
      )}
    </div>
  );
}

export default EditFiberCore;
